"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default(theme) {
  return {
    root: (0, _extends2.default)({}, theme.typography.defaultText, {
      fontWeight: '500',
      lineHeight: '20px'
    }),
    title: {
      color: theme.colors.text.white,
      display: 'block'
    },
    message: {
      color: theme.colors.text.white,
      display: 'block'
    },
    success: {
      '&$title': {
        color: theme.colors.text.green
      }
    },
    error: {
      '&$title': {
        color: theme.colors.text.red
      }
    }
  };
};

exports.default = _default;